import { useAnalytics, withEventContext } from "@codat/analytics";
import { Skeleton, StatsCircleIcon, ZeroState } from "@codat/orchard-ui";
import React, { FC, useEffect, useState } from "react";

import Page from "components/Page";

import { useDeleteApiKey, useGetApiKeys } from "./api";
import { ApiKeysTable } from "./ApiKeysTable";
import { CreateApiKeyModal } from "./CreateApiKeyModal";
import DeleteApiKeyModal from "./DeleteApiKeyModal/DeleteApiKeyModal";
import { Header } from "./Header";

export const ApiKeysContent: FC = () => {
  const { sendPageViewEvent } = useAnalytics();
  const [apiKeyToDelete, setApiKeyToDelete] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);

  const [{ data, loading: keysLoading, error }, refetchData] = useGetApiKeys();
  const [{ loading: deletingLoading }, deleteApiKey] =
    useDeleteApiKey(apiKeyToDelete);

  const isLoading = keysLoading || deletingLoading;
  const numberOfKeys = data?.length;

  useEffect(() => {
    sendPageViewEvent("API keys");
  }, [sendPageViewEvent]);

  return (
    <>
      <Page>
        <Header
          numberOfKeys={numberOfKeys}
          onCreateClick={() => {
            setShowCreateModal(true);
          }}
        />
        {error ? (
          <ZeroState title={error.message} icon={<StatsCircleIcon />} />
        ) : isLoading || data === undefined ? (
          <Skeleton width="100%" height="400px" data-testid="api-keys-table" />
        ) : (
          <ApiKeysTable
            onKeyDelete={(id) => setApiKeyToDelete(id)}
            keys={data}
          />
        )}
      </Page>
      {showCreateModal && (
        <CreateApiKeyModal
          onClose={() => setShowCreateModal(false)}
          onCreated={() => {
            setShowCreateModal(false);
            refetchData();
          }}
        />
      )}
      {apiKeyToDelete && (
        <DeleteApiKeyModal
          deleteApiKey={deleteApiKey}
          deletingLoading={deletingLoading}
          onSuccess={() => {
            setApiKeyToDelete("");
            refetchData();
          }}
          onCancel={() => {
            setApiKeyToDelete("");
          }}
        />
      )}
    </>
  );
};

export const ApiKeys = withEventContext(ApiKeysContent, "API keys");
